module.exports = __webpack_public_path__ + "static/sui-table-contextual-styles3-3a7f04256e4988bc1fd83225c1d59b71.png";